import { render, staticRenderFns } from "./taDividerOne.vue?vue&type=template&id=48763a38&scoped=true&"
import script from "./taDividerOne.vue?vue&type=script&lang=js&"
export * from "./taDividerOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48763a38",
  null
  
)

export default component.exports